// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1WdhS","productName":"Table_productName__3ADyB"};